// src/pages/Security.js

import React from 'react';

const securityData = [
  {
    title: "ALL PRODUCTS",
    items: [
      "CCTV", "NVR/DVR", "Transmission", "Bomb Jammer", "Biomatric-Access Control", "Storage",
      "Thermal Product", "Accessories", "Cable", "Rack", "Artificial Intelligence",
      "Internet Of Things", "Fighter Capsule", "More Product", "Video Door Phone", "Boom Barrier",
    ],
  },
  {
    title: "CCTV",
    items: [
      "Project Series", "Dome Camera", "IP Bullet Camera", "HD Bullet Camera", "PTZ Camera",
      "4G Camera", "Robo Camera", "Fisheye Camera", "Solar Camera", "Wireless Camera",
      "Explosion proof Camera", "Long Range Camera",
    ],
  },
  {
    title: "ACCESS CONTROL",
    items: ["Biomatric-Access Control", "Turnstile & Flap Barrier", "Intrusion Alarm"],
  },
  {
    title: "SMART TV",
    items: ["Home Series Display", "Commercial Series Display"],
  },
  {
    title: "NVR/DVR",
    items: ["NVR", "DVR"],
  },
  {
    title: "Fire Alarm system",
    items: [],
  },
];

const Security = () => {
  return (
    <div className="p-6 max-w-7xl mx-auto">
      <h1 className="text-4xl font-bold text-center mb-12">Security & Surveillance</h1>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8">
        {securityData.map((category, index) => (
          <div
            key={index}
            className="bg-accent shadow-md rounded-xl p-6 border border-secondary/10 hover:shadow-lg transition"
          >
            <h2 className="text-xl font-semibold text-primary mb-4">▪ {category.title}</h2>
            <ul className="list-disc list-inside text-secondary space-y-1 pl-1">
              {category.items.map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Security;
